import React from "react";
import { ITextureSelectorProps, UiTextureSelector } from "./ui";

interface IState {}

export class TextureSelector<TOption, TValue> extends React.Component<ITextureSelectorProps<TOption, TValue>, IState> {

  public render() {
    return (<UiTextureSelector {...this.props} />);
  }
}